var _g, _path, _defs;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgLogoPad(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 36,
    viewBox: "0 0 36 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 18,
    cy: 18,
    r: 15,
    fill: "#34A853"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 18,
    cy: 18,
    r: 14.5,
    stroke: "white"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M22.0511 24.6963H21.4713L19.2741 9.47992C19.2343 9.20443 18.9983 9 18.72 9H16.7043C16.426 9 16.19 9.20443 16.1502 9.47992L13.953 24.6963H13.3732C13.1671 24.6963 13 24.8635 13 25.0696V26.2467C13 26.4528 13.1671 26.6199 13.3732 26.6199H22.0511C22.2572 26.6199 22.4243 26.4528 22.4243 26.2467V25.0696C22.4244 24.8635 22.2572 24.6963 22.0511 24.6963ZM19.2273 16.9909L19.7755 20.7877L16.8216 18.5204L19.2273 16.9909ZM18.9766 15.254L17.1821 13.9155L18.6091 12.7094L18.9766 15.254ZM17.1892 10.1198H18.2351L18.4205 11.4027L16.8071 12.7663L17.1892 10.1198ZM16.5116 14.8123L18.3774 16.2043L16.1017 17.6511L16.5116 14.8123ZM15.877 19.2068L18.9398 21.5577L15.14 24.311L15.877 19.2068ZM16.774 24.5097L19.9778 22.1884L20.313 24.5097H16.774Z",
    fill: "white"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d",
    x: 0,
    y: 0,
    width: 36,
    height: 36,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1.5
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow",
    result: "shape"
  })))));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoPad);
export default __webpack_public_path__ + "static/media/LogoPad.4befd436.svg";
export { ForwardRef as ReactComponent };